<script>
    export let trickData = ["tips and tricks!!"];
    export let index = 0;
</script>

<style>
    .tricks-tab {
        margin: 0;
        margin-right: 0.5rem;
        margin-top: 1rem;
        padding-bottom: 2.5rem;
        height: 5.5rem;
    }
</style>

<div class="box lev1 light tricks-tab">
    {trickData[index]}
</div>